<template>

    <div style="">
        <el-footer style="margin-bottom: 0;background-color:#595959;padding-top: 15px" :class="{'heightPC':isPC,'heightPhone':!isPC}">
            <div >
                <el-row  style="padding: 5px" >
                    <el-col  :sm="3" :md="3" :lg="3" :xl="3"></el-col>
                    <el-col  :sm="18" :md="18" :lg="18" :xl="18" >

                        <div style="overflow: hidden;" v-if="isPC">
                            <div class="logo" >
                                <img src="@/assets/logo.png" alt="logo" title="logo" style="width: 100%;height: 100%">
                            </div>
                            <div style="float: right;height: 130px;width: 100px">
                                <img src="@/assets/wechat2.png" style="height: 100px;width: 100%" alt="wechat" title="wechat">
                                <i style="font-style: normal;display: block;width: 100%;color: rgba(255, 255, 255, 0.6);text-align: center">WeChat</i>
                            </div>
                        </div>
                        <div style="overflow: hidden" v-else>
                            <div class="logo" style="float:left;width: 247px;height: 70px;text-align: center" >
                                <img src="@/assets/logo.png" alt="logo" title="logo" style="width: 100%;height: 100%">
                            </div>
                            <div style="float: right;height: 70px;width: 70px">
                                <img src="@/assets/wechat2.png" style="height: 100%;width: 100%" alt="wechat" title="wechat">
                                <i style="font-style: normal;display: block;width: 100%;color: rgba(255, 255, 255, 0.6);text-align: center">WeChat</i>
                            </div>
                        </div>
                        <div>
                            <ul>
                                <li @click="this.$router.push('/Products/de')">Produkt</li>
                                <li @click="this.$router.push('/About/de')">ÜberUns</li>
                                <li @click="this.$router.push('/News/de')">News</li>
                                <li @click="this.$router.push('/Contact/de')">KontaktierenSieUns</li>
                                <li @click="download" v-if="isPC">Download</li>
                            </ul>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-footer>


    </div>

</template>

<script>
    import { Ship,ArrowRightBold,Right,Back } from "@element-plus/icons";
    import Header from "@/ZH-CN/Header";
    import request from "@/utils/request";
    import Page4 from "@/ZH-CN/slot/Page4";
    export default {
        name: 'Foot',
        components: {
            Ship,ArrowRightBold,Right,Back
        },

        data() {
            return {

                url:"../assets/logo.png",
                isPC:false,


            }
        },

        methods: {

            _isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            },
            download(){
                if (this.$route.path=="/de/Home"){
                    this.$emit('changeMsg', true)
                }else {
                    sessionStorage.setItem("imgIndex",3)
                    this.$router.push({name:"Home_de",params:{key:true}})



                }

            }
        },
        mounted(index){

            if (this._isMobile()) {
                this.isPC=false;
            } else {
                // alert("pc端");
                // this.$router.replace('/test');
                this.isPC=true;
            }
            request.get("/nav/footer/de").then(res =>{
                this.datas = res.data;
            }).catch((res)=>{
            })
        }


    }
</script>


<style scoped>

    ul{
        list-style: none !important;
        border-top:1px solid rgba(255,255,255,.1) ;
        border-bottom:1px solid rgba(255,255,255,.1) ;
        color: #fff !important;
        overflow: hidden;
        flex-wrap: wrap;
        margin-top: 15px;



    }
    ul li{
        float: left;
        margin-right: 1.5vw;
        padding: 30px 0;
        font-size: 1em;
        cursor: pointer;
    }

    .heightPC{
        height: 40vh;
    }

    .heightPhone{
        height: 35vh;
    }
    @media screen and (max-width: 400px){
        ul{
            list-style: none !important;
            border-top:1px solid rgba(255,255,255,.1) ;
            border-bottom:1px solid rgba(255,255,255,.1) ;
            color: #fff !important;

            margin-top: 15px;

            display: -webkit-flex; /* Safari */
            -webkit-justify-content: space-between; /* Safari 6.1+ */
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            -webkit-box-pack: justify

        }
        ul li{

            float: left;
            margin-right: 1.5vw;
            padding: 30px 0;
            font-size: .8em;
            cursor: pointer;
        }

        .logo{
            float:left;
            height: 50px !important;
            width:176px  !important;
        }
    }
    .logo{
        float:left;width: 353px;height: 100px;
    }
</style>

